import { Discount } from '../types';

function getDaySuffix(day: number) {
  return (
    day +
    (day > 0 ? ['th', 'st', 'nd', 'rd'][(day > 3 && day < 21) || day % 10 > 3 ? 0 : day % 10] : '')
  );
}

const getTrialExpiryDate = (
  discount?: Discount | null,
  hasLongerTrialFlag?: boolean,
  showYear: boolean = true,
) => {
  let trialDays = hasLongerTrialFlag ? 14 : 7;

  if (discount?.trialDays) {
    trialDays = discount.trialDays;
  }

  const now = new Date();
  const ONE_WEEK_IN_MILLISECONDS = trialDays * 24 * 60 * 60 * 1000;
  const date = new Date(now.getTime() + ONE_WEEK_IN_MILLISECONDS);
  return `${getDaySuffix(date.getDate())} ${date.toLocaleString('default', {
    month: 'long',
  })}${showYear ? ` ${date.getFullYear()}` : ''}`;
};

export default getTrialExpiryDate;
